import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initVersionCheck } from "@/lib/versionCheck";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Recarga automática cuando se detecta un deploy nuevo (ver lib/versionCheck).
initVersionCheck();
